var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-link',{staticClass:"text-info ml-2",attrs:{"disabled":_vm.disabled,"title":"Visualizar"},on:{"click":function($event){return _vm.$emit('visualizar')}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'eye']}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }